"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$noControlAnonymParagraph = exports.$paragraphItem = exports.$requireControlParagraphItem = exports.$autoParagraphItem = exports.paragraphItemFromAuto = exports.isAutoParagraphItemSentence = exports.isAutoParagraphItemTitle = exports.isAutoParagraphItem = exports.$autoParagraphItemChildrenOuter = exports.paragraphItemToLines = void 0;
const line_1 = require("../../../node/cst/line");
const std = __importStar(require("../../../law/std"));
const columnsOrSentences_1 = require("./columnsOrSentences");
const toCSTSettings_1 = __importDefault(require("../toCSTSettings"));
const _sentenceChildren_1 = __importStar(require("../../cst/rules/$sentenceChildren"));
const util_1 = require("../../../util");
const inline_1 = require("../../../node/cst/inline");
const util_2 = require("../util");
const factory_1 = __importDefault(require("../factory"));
const virtualLine_1 = require("../virtualLine");
const util_3 = require("../util");
const error_1 = require("../../cst/error");
const el_1 = require("../../../node/el");
const _amendProvision_1 = __importStar(require("./$amendProvision"));
const _list_1 = require("./$list");
const _tableStruct_1 = __importStar(require("./$tableStruct"));
const _figStruct_1 = __importStar(require("./$figStruct"));
const _noteLike_1 = require("./$noteLike");
const _paragraphItemLine_1 = require("../../cst/rules/$paragraphItemLine");
const _tagControl_1 = require("../../cst/rules/$tagControl");
const num_1 = require("../../../law/num");
const env_1 = require("../../cst/env");
const reOldParagraphNum = new RegExp(`^(?:○[0123456789０１２３４５６７８９]+|[${num_1.circledDigitChars}])`);
const reAmendingText = /.*?の一部を次のように(?:改正す|改め)る。$/;
/**
 * The renderer for Paragraph, Item and subitem ({@link std.ParagraphItem | ParagraphItem}). Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$paragraphItem.spec.ts) for examples.
 */
const paragraphItemToLines = (el, indentTexts, options) => {
    const lines = [];
    const { firstArticleParagraphArticleTitle, secondaryArticleParagraph, noControl, 
    // requireControl,
    defaultTag, } = {
        firstArticleParagraphArticleTitle: undefined,
        secondaryArticleParagraph: false,
        noControl: false,
        // requireControl: false,
        defaultTag: null,
        ...options,
    };
    const ParagraphCaption = [];
    const ParagraphItemTitle = [];
    let ParagraphItemSentence;
    const Children = [];
    for (const child of el.children) {
        if (child.tag === "ParagraphCaption") {
            ParagraphCaption.push(...child.children);
        }
        else if (std.isArticleCaption(child)) {
            console.error(`Unexpected ${el.tag} in ${el.tag}!`);
            ParagraphCaption.push(...child.children);
        }
        else if (std.isParagraphItemTitle(child)) {
            ParagraphItemTitle.push(...child.children);
        }
        else if (std.isParagraphItemSentence(child)) {
            ParagraphItemSentence = child;
        }
        else if (std.isParagraphItem(child) || child.tag === "AmendProvision" || child.tag === "Class" || child.tag === "TableStruct" || child.tag === "FigStruct" || child.tag === "StyleStruct" || child.tag === "List") {
            Children.push(child);
        }
        else {
            (0, util_1.assertNever)(child);
        }
    }
    if (ParagraphCaption.length > 0) {
        const newIndentTexts = [...indentTexts, toCSTSettings_1.default.INDENT];
        const captionString = (0, _sentenceChildren_1.sentenceChildrenToString)(ParagraphCaption);
        const result = _sentenceChildren_1.default.match(0, captionString, (0, env_1.initialEnv)({}));
        if (!result.ok) {
            const message = `addControls: Error: ${captionString}`;
            throw new Error(message);
        }
        const line = new line_1.OtherLine({
            range: null,
            indentTexts: newIndentTexts,
            controls: [],
            sentencesArray: [
                new inline_1.Sentences("", null, [], [std.newStdEL("Sentence", {}, result.value.value)]),
            ],
            lineEndText: toCSTSettings_1.default.EOL,
        });
        if (!(0, util_2.isSingleParentheses)(line)) {
            line.controls.push(new inline_1.Control(util_2.captionControl, null, "", null));
        }
        lines.push(line);
    }
    const Title = ParagraphItemTitle;
    if (firstArticleParagraphArticleTitle
        && firstArticleParagraphArticleTitle.length > 0)
        Title.push(...firstArticleParagraphArticleTitle);
    let paragraphItemTitleStr = (0, _sentenceChildren_1.sentenceChildrenToString)(Title);
    const oldNum = (paragraphItemTitleStr.length === 0 && el.tag === "Paragraph" && el.attr.OldNum === "true");
    if (oldNum) {
        paragraphItemTitleStr = num_1.circledDigitChars[Number(el.attr.Num)];
    }
    const MissingNum = (secondaryArticleParagraph && Title.length === 0 && el.tag === "Paragraph" && el.attr.OldNum !== "true") ? "true" : undefined;
    const SentenceChildren = ParagraphItemSentence ? ParagraphItemSentence.children : [];
    const sentencesArray = (0, columnsOrSentences_1.columnsOrSentencesToSentencesArray)(SentenceChildren);
    if (MissingNum) {
        sentencesArray[0].attrEntries.unshift(new inline_1.AttrEntry(`[MissingNum="${MissingNum}"]`, ["MissingNum", "${MissingNum}"], null, "", null));
    }
    if (firstArticleParagraphArticleTitle) {
        const title = (0, _sentenceChildren_1.sentenceChildrenToString)(firstArticleParagraphArticleTitle);
        lines.push(new line_1.ArticleLine({
            range: null,
            indentTexts,
            title,
            midSpace: (title.length === 0 || sentencesArray.length === 0) ? "" : toCSTSettings_1.default.MARGIN,
            sentencesArray,
            lineEndText: toCSTSettings_1.default.EOL,
        }));
    }
    else if (noControl
        && ParagraphCaption.every(c => (typeof c !== "string" && !c.text()) && !c)
        && ParagraphItemTitle.every(c => (typeof c !== "string" && !c.text()) && !c)
    // && paragraphItemTitleStr.length > 0
    ) {
        lines.push(new line_1.ParagraphItemLine({
            range: null,
            indentTexts,
            mainTag: el.tag,
            controls: [],
            title: paragraphItemTitleStr,
            midSpace: (Title.length === 0 || sentencesArray.length === 0) ? "" : toCSTSettings_1.default.MARGIN,
            sentencesArray,
            lineEndText: toCSTSettings_1.default.EOL,
        }));
    }
    else if (paragraphItemTitleStr.length > 0) {
        const controls = [];
        if ((el.tag === defaultTag)
            && (0, _paragraphItemLine_1.unknownParagraphItemTitleMatch)(paragraphItemTitleStr).ok) {
            // e.g.
            //  │第一条・・・
            //  │　一    <- Item
            //  │　１    <- Item
            //   -> If "一" or "１" appears as Item, no control needed.
        }
        else if (((el.tag in _paragraphItemLine_1.paragraphItemTitleRule)
            && (_paragraphItemLine_1.paragraphItemTitleMatch[el.tag](paragraphItemTitleStr).ok))
            || ((el.tag === "Paragraph")
                && (el.attr.OldNum === "true")
                && reOldParagraphNum.test(paragraphItemTitleStr))) {
            // e.g.
            //  │第一条・・・
            //  │　# １             <- Paragraph
            //   -> If "１" appears as Paragraph, auto control needed.
            controls.push(new inline_1.Control(_tagControl_1.autoTagControls[0], null, " ", null));
        }
        else {
            // e.g.
            //  │第一条・・・
            //  │　:paragraph:一    <- Paragraph
            //   -> If "一" appears as Paragraph, specified control needed.
            controls.push(new inline_1.Control(_tagControl_1.paragraphItemControls[el.tag], null, "", null));
        }
        lines.push(new line_1.ParagraphItemLine({
            range: null,
            indentTexts,
            mainTag: el.tag,
            controls,
            title: paragraphItemTitleStr,
            midSpace: (sentencesArray.length === 0) ? "" : toCSTSettings_1.default.MARGIN,
            sentencesArray,
            lineEndText: toCSTSettings_1.default.EOL,
        }));
    }
    else {
        lines.push(new line_1.ParagraphItemLine({
            range: null,
            indentTexts,
            mainTag: el.tag,
            controls: [
                new inline_1.Control(_tagControl_1.anonymParagraphItemControls[el.tag], null, "", null)
            ],
            title: "",
            midSpace: "",
            sentencesArray,
            lineEndText: toCSTSettings_1.default.EOL,
        }));
    }
    for (const [ci, child] of Children.entries()) {
        if (std.isParagraphItem(child)) {
            lines.push(...(0, exports.paragraphItemToLines)(child, [...indentTexts, toCSTSettings_1.default.INDENT], {
                defaultTag: std.paragraphItemTags[std.paragraphItemTags.indexOf(el.tag) + 1],
            })); /* >>>> INDENT >>>> */
        }
        else if (child.tag === "TableStruct") {
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
            const withControl = ((0 <= (ci - 1) && std.isTableStruct((Children[ci - 1]))) ||
                ((ci + 1) < Children.length && std.isTableStruct((Children[ci + 1]))));
            lines.push(...(0, _tableStruct_1.tableStructToLines)(child, [...indentTexts, toCSTSettings_1.default.INDENT], { withControl })); /* >>>> INDENT >>>> */
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        }
        else if (child.tag === "FigStruct") {
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
            lines.push(...(0, _figStruct_1.figStructToLines)(child, [...indentTexts, toCSTSettings_1.default.INDENT])); /* >>>> INDENT >>>> */
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        }
        else if (child.tag === "StyleStruct") {
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
            lines.push(...(0, _noteLike_1.noteLikeStructToLines)(child, [...indentTexts, toCSTSettings_1.default.INDENT])); /* >>>> INDENT >>>> */
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        }
        else if (child.tag === "List") {
            lines.push(...(0, _list_1.listOrSublistToLines)(child, [...indentTexts, toCSTSettings_1.default.INDENT])); /* >>>> INDENT >>>> */
        }
        else if (child.tag === "AmendProvision") {
            const lastText = sentencesArray.slice(-1)[0]
                ?.sentences.slice(-1)[0]
                ?.text() ?? "";
            lines.push(...(0, _amendProvision_1.amendProvisionToLines)(child, [...indentTexts, toCSTSettings_1.default.INDENT], { withControl: !reAmendingText.test(lastText) })); /* >>>> INDENT >>>> */
        }
        else if (child.tag === "Class") {
            throw new util_1.NotImplementedError(child.tag);
        }
        else {
            (0, util_1.assertNever)(child);
        }
    }
    return lines;
};
exports.paragraphItemToLines = paragraphItemToLines;
const $autoParagraphItemNotAmendChildrenBlock = (0, util_2.makeIndentBlockWithCaptureRule)("$paragraphItemNotAmendChildrenBlock", (factory_1.default
    .choice(c => c
    // .orSequence(s => s
    //     .and(() => $listsOuter, "content")
    //     .action(({ content }) => {
    //         return {
    //             value: content.value.map(c => c.value),
    //             errors: [
    //                 ...content.errors,
    //                 ...content.value.map(c => c.errors).flat(),
    //             ],
    //         };
    //     })
    // )
    .orSequence(s => s
    .and(r => r
    .choice(c => c
    .orSequence(s => s
    .and(() => exports.$autoParagraphItem, "elWithErrors")
    .and(r => r.assert(({ elWithErrors }) => !std.isParagraph(elWithErrors.value)))
    .action(({ elWithErrors }) => {
    return elWithErrors;
}))
    .or(() => _list_1.$list)
    .or(() => _tableStruct_1.default)
    .or(() => _figStruct_1.default)
    .or(() => _noteLike_1.$styleStruct)), "content")
    .action(({ content }) => {
    return {
        value: [content.value],
        errors: content.errors,
    };
})))));
const $amendProvisionsBlock = (0, util_2.makeIndentBlockWithCaptureRule)("$amendProvisionsBlock", (factory_1.default.ref(() => _amendProvision_1.default)));
exports.$autoParagraphItemChildrenOuter = factory_1.default
    .withName("paragraphItemChildrenOuter")
    .sequence(s => s
    .and(r => r
    .choice(c => c
    .orSequence(s => s
    .andOmit(r => r
    .choice(c => c
    .or(r => r
    .assert(({ firstParagraphItemLine }) => {
    const lastText = firstParagraphItemLine.line
        .sentencesArray.slice(-1)[0]
        ?.sentences.slice(-1)[0]
        ?.text() ?? "";
    return reAmendingText.test(lastText);
}))
    .or(r => r
    .nextIs(r => r
    .sequence(s => s
    .andOmit(() => util_2.$optBNK_INDENT)
    .and(r => r
    .oneMatch(({ item }) => {
    if (item.type === line_1.LineType.OTH
        && item.line.controls.some(c => c.control === ":amend-provision:")) {
        return item;
    }
    else {
        return null;
    }
})))))))
    .and(() => $amendProvisionsBlock, "block")
    .action(({ block }) => {
    return {
        value: block.value.map(c => c.value),
        errors: [
            ...block.errors,
            ...block.value.map(c => c.errors).flat(),
        ],
    };
}))
    .orSequence(s => s
    .and(() => $autoParagraphItemNotAmendChildrenBlock, "block")
    .action(({ block }) => {
    return {
        value: block.value.map(c => c.value).flat(),
        errors: [
            ...block.errors,
            ...block.value.map(c => c.errors).flat(),
        ],
    };
}))), "childrenBlock")
    .action(({ childrenBlock }) => {
    const value = [];
    const errors = [];
    value.push(...childrenBlock.value);
    errors.push(...childrenBlock.errors);
    return {
        value,
        errors,
    };
}));
const isAutoParagraphItem = (el) => typeof el !== "string" && el.tag === "__AutoParagraphItem";
exports.isAutoParagraphItem = isAutoParagraphItem;
// type __AutoParagraphItemTitle = EL & {tag: "__AutoParagraphItemTitle"};
const isAutoParagraphItemTitle = (el) => typeof el !== "string" && el.tag === "__AutoParagraphItemTitle";
exports.isAutoParagraphItemTitle = isAutoParagraphItemTitle;
// type __AutoParagraphItemSentence = EL & {tag: "__AutoParagraphItemSentence"};
const isAutoParagraphItemSentence = (el) => typeof el !== "string" && el.tag === "__AutoParagraphItemSentence";
exports.isAutoParagraphItemSentence = isAutoParagraphItemSentence;
const paragraphItemFromAuto = (defautTag, paragraphItem) => {
    const tag = paragraphItem.tag === "__AutoParagraphItem" ? defautTag : paragraphItem.tag;
    const attr = {};
    Object.assign(attr, paragraphItem.attr);
    const children = paragraphItem.children.map(c => {
        if (std.isParagraphItem(c) || (0, exports.isAutoParagraphItem)(c)) {
            return (0, exports.paragraphItemFromAuto)(std.paragraphItemTags[std.paragraphItemTags.indexOf(tag) + 1], c);
        }
        else if ((0, exports.isAutoParagraphItemTitle)(c)) {
            return std.newStdEL(std.paragraphItemTitleTags[std.paragraphItemTags.indexOf(tag)], c.attr, c.children, c.range);
        }
        else if ((0, exports.isAutoParagraphItemSentence)(c)) {
            return std.newStdEL(std.paragraphItemSentenceTags[std.paragraphItemTags.indexOf(tag)], c.attr, c.children, c.range);
        }
        else {
            return c;
        }
    });
    const titleEL = children.find(std.isParagraphItemTitle);
    const titleStr = titleEL ? titleEL.text() : "";
    const num = titleStr ? (0, num_1.parseNamedNum)(titleStr) : null; // Assume KanaMode.Iroha tentatively
    if (num)
        attr.Num = num;
    if (tag === "Paragraph" && titleEL && reOldParagraphNum.test(titleStr)) {
        attr.OldNum = "true";
        titleEL.children.splice(0, titleEL.children.length);
    }
    return std.newStdEL(tag, attr, children, paragraphItem.range);
};
exports.paragraphItemFromAuto = paragraphItemFromAuto;
exports.$autoParagraphItem = factory_1.default
    .withName("autoParagraphItem")
    .sequence(s => s
    .and(r => r
    .zeroOrOne(r => r
    .sequence(s => s
    .and(r => r
    .oneMatch(({ item }) => {
    if (item.type === virtualLine_1.VirtualOnlyLineType.CAP) {
        return item;
    }
    else {
        return null;
    }
}))
    .andOmit(r => r.zeroOrMore(() => util_3.$blankLine)))), "captionLine")
    .and(r => r
    .oneMatch(({ item }) => {
    if (item.type === line_1.LineType.PIT) {
        return item;
    }
    else {
        return null;
    }
}), "firstParagraphItemLine")
    .and(r => r
    .zeroOrOne(() => exports.$autoParagraphItemChildrenOuter), "tailChildren")
    .action(({ captionLine, firstParagraphItemLine, tailChildren }) => {
    const tag = firstParagraphItemLine.line.mainTag ?? "__AutoParagraphItem";
    const paragraphItem = new el_1.EL(tag);
    const errors = tailChildren?.errors ?? [];
    if (firstParagraphItemLine.line.sentencesArray.length >= 1) {
        const replacedAttrEntries = [];
        for (const attrEntry of firstParagraphItemLine.line.sentencesArray[0].attrEntries) {
            if (attrEntry.entry[0] === "OldNum" && attrEntry.entry[1] !== std.defaultAttrs.Paragraph.OldNum) {
                paragraphItem.attr.OldNum = attrEntry.entry[1];
            }
            else {
                replacedAttrEntries.push(attrEntry);
            }
        }
        firstParagraphItemLine.line.sentencesArray[0].attrEntries.splice(0);
        firstParagraphItemLine.line.sentencesArray[0].attrEntries.push(...replacedAttrEntries);
    }
    if (captionLine) {
        paragraphItem.children.push(std.newStdEL("ParagraphCaption", {}, captionLine.line.sentencesArray
            .map(sa => sa.sentences.map(s => s.children))
            .flat(2), captionLine.line.sentencesArrayRange));
    }
    paragraphItem.children.push(std.newStdEL(tag !== "__AutoParagraphItem"
        ? std.paragraphItemTitleTags[std.paragraphItemTags.indexOf(tag)]
        : "__AutoParagraphItemTitle", {}, firstParagraphItemLine.line.title ? [firstParagraphItemLine.line.title] : [], firstParagraphItemLine.line.titleRange));
    const sentencesArrayRange = firstParagraphItemLine.line.sentencesArrayRange;
    const paragraphItemSentencePos = firstParagraphItemLine.line.indentsEndPos;
    paragraphItem.children.push(std.newStdEL(tag !== "__AutoParagraphItem"
        ? std.paragraphItemSentenceTags[std.paragraphItemTags.indexOf(tag)]
        : "__AutoParagraphItemSentence", {}, (0, columnsOrSentences_1.sentencesArrayToColumnsOrSentences)(firstParagraphItemLine.line.sentencesArray), sentencesArrayRange ?? (paragraphItemSentencePos !== null ? [paragraphItemSentencePos, paragraphItemSentencePos] : null)));
    if (tailChildren) {
        paragraphItem.children.push(...tailChildren.value);
    }
    const pos = captionLine ? captionLine.line.indentsEndPos : firstParagraphItemLine.line.indentsEndPos;
    const range = (0, el_1.rangeOfELs)(paragraphItem.children) ?? (pos !== null ? [pos, pos] : null);
    if (range && pos !== null) {
        range[0] = pos;
    }
    paragraphItem.range = range;
    return {
        value: paragraphItem,
        errors,
    };
}));
exports.$requireControlParagraphItem = factory_1.default
    .withName("$paragraphItem")
    .sequence(s => s
    .and(() => exports.$autoParagraphItem, "autoParagraphItem")
    .action(({ autoParagraphItem }) => {
    let defautTag;
    const errors = [];
    errors.push(...autoParagraphItem.errors);
    if (autoParagraphItem.value.tag === "__AutoParagraphItem") {
        defautTag = "Paragraph";
        errors.push(new error_1.ErrorMessage("$requireControlParagraphItem: 制御記号（\":paragraph:\" や \"#\" など）が必要です。", autoParagraphItem.value.range ?? [0, 0]));
    }
    else {
        defautTag = autoParagraphItem.value.tag;
    }
    return {
        value: (0, exports.paragraphItemFromAuto)(defautTag, autoParagraphItem.value),
        errors,
    };
}));
/**
 * The parser rule for Paragraph, Item and subitem ({@link std.ParagraphItem | ParagraphItem}). Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$paragraphItem.spec.ts) for examples.
 */
const $paragraphItem = (defautTag) => factory_1.default
    .withName("$paragraphItem")
    .sequence(s => s
    .and(() => exports.$autoParagraphItem, "autoParagraphItem")
    .action(({ autoParagraphItem }) => ({
    value: (0, exports.paragraphItemFromAuto)(defautTag, autoParagraphItem.value),
    errors: autoParagraphItem.errors,
})));
exports.$paragraphItem = $paragraphItem;
exports.$noControlAnonymParagraph = factory_1.default
    .withName("noControlAnonymParagraph")
    .sequence(s => s
    .and(r => r
    .oneMatch(({ item }) => {
    if (item.type === line_1.LineType.OTH
        && item.line.controls.length === 0) {
        return item;
    }
    else {
        return null;
    }
}), "firstParagraphItemLine")
    .and(r => r
    .zeroOrOne(() => exports.$autoParagraphItemChildrenOuter), "tailChildren")
    .action(({ firstParagraphItemLine, tailChildren }) => {
    const sentencesArrayRange = firstParagraphItemLine.line.sentencesArrayRange;
    const paragraph = std.newStdEL("Paragraph", {
    // OldStyle: "false",
    }, [
        std.newStdEL("ParagraphNum", {}, [], sentencesArrayRange ? [sentencesArrayRange[0], sentencesArrayRange[0]] : null),
        std.newStdEL("ParagraphSentence", {}, (0, columnsOrSentences_1.sentencesArrayToColumnsOrSentences)(firstParagraphItemLine.line.sentencesArray), sentencesArrayRange),
    ]);
    if (tailChildren) {
        paragraph.children.push(...tailChildren.value);
    }
    const pos = firstParagraphItemLine.line.indentsEndPos;
    const range = (0, el_1.rangeOfELs)(paragraph.children) ?? (pos !== null ? [pos, pos] : null);
    if (range && pos !== null) {
        range[0] = pos;
    }
    paragraph.range = range;
    return {
        value: (0, exports.paragraphItemFromAuto)("Paragraph", paragraph),
        errors: tailChildren?.errors ?? [],
    };
}));
exports.default = exports.$paragraphItem;
//# sourceMappingURL=$paragraphItem.js.map